import { BrowserMetrics } from './browserMetrics';
import { EventBusMonitor } from './eventBusObservability/EventBusMonitor';
import { EventBusWrapper } from './eventBusObservability/EventBusWrapper';
// import { EventListenerTracker } from './eventListenerTracker';
import { FirestoreMonitor } from './firestoreObservability/FirestoreMonitor';
import { FirestoreWrapper } from './firestoreObservability/FirestoreWrapper'
import { MemoryAnalyzer } from './memoryAnalyzer';
import { MicroAppsMonitor } from './micro-apps/MicroAppsMonitor';
import { MicroFrontendAppWrapper } from './micro-apps/MicroFrontendAppWrapper';
import {
  componentLifecycleTracker
} from '../../util/performance-debugger/component-lifecycle';
import { PerformanceMonitor } from './performanceMonitor';
import { componentUpdateTracker } from '../../util/performance-debugger/component-updates';
// import { OpenListenerTracker } from './listner/OpenListnerTracker';
// import { eventBusDebugger } from './eventBusDebugger';
// import { firestoreDebugger } from './firestoreDebugger';
import { v4 as uuidv4 } from 'uuid';
import modalHub from '../../plugins/modal-hub'
const isDevelopmentMode = ['development', 'staging'].includes(process.env.NODE_ENV || '');

let inited = false;
const enableVueScan = isDevelopmentMode && process.env.VUE_APP_ENABLE_VUE_SCAN == 'true'
if (enableVueScan) {
  // Dynamic imports for debugging tools
  const Vue = require('vue').default
  const VueScan = require('z-vue-scan/vue2')
  Vue.use(VueScan)

  // if you want to enable component updates tracker, uncomment the following line
  // this will track all the component updates and log them to the console
  // check for logs in the console with the tag [DEBUG] [Component Updates]
  // ComponentUpdateTracker.enable()
  // EventListenerTracker.enable()
  // ObserverTracker.enable()
}

/**
 * Initializes the debugging system for development and staging environments.
 * Sets up plugins for Firestore and EventBus debugging, and exposes them on the window object.
 */
export function initDebugging(router: any) {
  // adding modal-hub initialization
  modalHub.register()

  if (process.env.VUE_APP_DISABLE_PERFORMANCE_DEBUGGER === 'true') return;

  if (inited) return;
  const debugSessionId = uuidv4();
  inited = true

  const monitor = FirestoreMonitor.getInstance({
    enableApiLogger: process.env.NODE_ENV !== 'development',
  });
  BrowserMetrics.setFirestoreMonitor(monitor);
  const firestoreWrapper = FirestoreWrapper.getInstance(monitor);
  firestoreWrapper.initialize();

  // Initialize Micro Apps monitoring

  // Check if MicroApps monitoring is already initialized
  const existingMicroAppsMonitor = BrowserMetrics.getMicroAppsMonitor();
  if (existingMicroAppsMonitor) {
    // If already initialized, just return
    return;
  }

  const microAppsMonitor = MicroAppsMonitor.getInstance();
  BrowserMetrics.setMicroAppsMonitor(microAppsMonitor);
  MicroFrontendAppWrapper.getInstance(microAppsMonitor);
  microAppsMonitor.initialize();

  // Initialize component lifecycle tracker
  // const componentLifecycleTracker = BrowserMetrics.getComponentLifecycleTracker();
  // OpenListenerTracker.getInstance().initialize();

  router.afterEach((to: any, from: any) => {
    PerformanceMonitor.sendMetrics(to, from, debugSessionId);
    
    // Send memory metadata on route changes
    if ((window as any).MemoryMonitor) {
      (window as any).MemoryMonitor.sendRouteMemoryMetadata();
    }
  })

  if (!isDevelopmentMode) return;

  // Initialize plugins
  const eventBusMonitor = EventBusMonitor.getInstance();
  BrowserMetrics.setEventBusMonitor(eventBusMonitor);
  EventBusWrapper.getInstance(eventBusMonitor, {
    enabled: true,
    listenedForComponents: ['global-event-bus', 'conversation-event-bus', 'global-event-bus-instance'],
    enableEmitHook: false
  }).initialize();

  componentLifecycleTracker?.enable()

  MemoryAnalyzer.register();

  BrowserMetrics.setComponentUpdateTracker(componentUpdateTracker as any);

  // ===== EventBus Debugging =====
  // eventBusDebugger.setSessionId(debugSessionId);
  // eventBusDebugger.registerPlugin(consoleLogger);
  // eventBusDebugger.registerPlugin(reactiveStore);
  // eventBusDebugger.init();

  // ===== Expose for debugging =====
  // Make debugging tools available on the window object
}
